import { createAction, props } from '@ngrx/store'
import { ListedMetric } from '@core/models/metric.models'
import { ContextMenuEntity, ContextMenuItem, ContextMenuItemEvent } from '@core/models/context-menu.models'
import { MetricItemContextMenu } from '@core/enums/metric-context-menu.enum'

/**
 * @deprecated since v4.3.0
 */
export const clickContextMenuItem = createAction(
  '[ContextMenu] click item',
  props<{ menuItem: ContextMenuItem; value: ListedMetric; valueContext: ContextMenuEntity }>()
)

export const clickOnContextMenuItem = createAction(
  '[ContextMenu] click on context menu item',
  props<{ menuItem: MetricItemContextMenu } & ContextMenuItemEvent>()
)
